var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.6667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.983 0c-3.206 0.052-6.263 1.365-8.51 3.653-2.271 2.261-3.525 5.349-3.473 8.554-8e-3 6.505 5.26 11.785 11.765 11.793h0.035 0.214c6.678-0.069 12.04-5.531 11.986-12.209v0c0.015-6.498-5.24-11.778-11.738-11.794-0.093 0-0.186 1e-3 -0.279 3e-3zm-1.483 16.542c-0.03-0.815 0.606-1.499 1.421-1.529 9e-3 0 0.019-1e-3 0.028-1e-3h0.027c0.82 2e-3 1.492 0.651 1.523 1.47 0.03 0.814-0.605 1.499-1.419 1.529-0.01 0-0.02 1e-3 -0.03 1e-3h-0.027c-0.82-3e-3 -1.491-0.651-1.523-1.47zm0.5-4.042v-6c0-0.552 0.448-1 1-1s1 0.448 1 1v6c0 0.552-0.448 1-1 1s-1-0.448-1-1z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.98edc35e39004edc41486dcbb3869438.svg";
export { ForwardRef as ReactComponent };